import { render, staticRenderFns } from "./UserSave.vue?vue&type=template&id=c50c50fa&scoped=true&"
import script from "./UserSave.vue?vue&type=script&lang=js&"
export * from "./UserSave.vue?vue&type=script&lang=js&"
import style0 from "./UserSave.vue?vue&type=style&index=0&id=c50c50fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50c50fa",
  null
  
)

export default component.exports